import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { logger } from '@/utils/logging';

import { PicksValidationProcessor, ValidateResponse } from '.';
import { useBetslipStore } from '../hooks/use-betslip-store';
import { getInvalidPicksError } from '../utils/betslip-utils';

const LOG_TAG = '[Betslip-Invalid-Picks]';

type Context = {
    syncPicks: (opts: {
        expectError: boolean;
        promptIfOddsChanged?: boolean;
        infoModalDismissBehaviour?: 'goBack' | 'none';
    }) => void;
};

export class InvalidPicksProcessor extends PicksValidationProcessor<Context> {
    process(data: ValidateResponse): void {
        const activeGameMode = useBetslipStore.getState().activeGameMode;
        const result = data.validateEntryOnEntryRules.find(it => it.gameMode === activeGameMode);

        if (!result) {
            logger.warn(LOG_TAG, `No validation result for active ${activeGameMode} game mode found.`);
            return;
        }

        const invalidPicksError = getInvalidPicksError(result);

        if (invalidPicksError) {
            logger.debug(LOG_TAG, 'Found invalid picks, sync picks to determine which.');

            BetrAnalytics.trackEvent(AnalyticsEvent.PRE_SUBMIT_ERRORS, {
                errorCode: invalidPicksError.code,
                errorKey: invalidPicksError.key,
            });

            this.context.syncPicks({ expectError: false });
        }

        this.nextProcessor?.process(data);
    }
}
